import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import PageScrollTop from "./components/pageToTop/PageScrollTop";

// Pages import Here
import BusinessConsulting2 from "./pages/BusinessConsulting2";
import StaffRecruitment from "./pages/StaffRecruitment";
import TagList from "./pages/TagList";
import AboutUs from "./pages/AboutUs";
import AboutScale from "./pages/AboutUsScale";
import AboutPartner from "./pages/AboutUsPartner";
import ServicePage from "./pages/Service";
import FreeConsult from "./pages/FreeConsult";

// Elements import Here
import Contact from "./elements/contact/Contact";
import BlogGridView from "./components/blog/BlogGridView";

import "./i18n";
import ReactGA from "react-ga";
import React, { useEffect } from "react";

// Import Css Here
import "./assets/scss/style.scss";
import "./assets/css/dddi-theme.css";

const App = () => {
  useEffect(() => {
    ReactGA.set({ userId: "G-CC2486B96D" });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <Router>
      <PageScrollTop>
        <Switch>
          <Route
            path={`${process.env.PUBLIC_URL + "/"}`}
            exact
            component={BusinessConsulting2}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/AboutUs"}`}
            exact
            component={AboutUs}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/AboutScale"}`}
            exact
            component={AboutScale}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/AboutPartner"}`}
            exact
            component={AboutPartner}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/Service"}`}
            exact
            component={ServicePage}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/contact"}`}
            exact
            component={Contact}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/blog-grid"}`}
            exact
            component={BlogGridView}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/tag/:slug"}`}
            exact
            component={TagList}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/StaffRecruitment"}`}
            exact
            component={StaffRecruitment}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/FreeConsult"}`}
            exact
            component={FreeConsult}
          />

          {/* Legacy routes from the pre-DDDI positioning — redirect to the
              consolidated services page so old inbound links keep working. */}
          <Redirect
            from={`${process.env.PUBLIC_URL + "/CaseStudy"}`}
            to={`${process.env.PUBLIC_URL + "/"}`}
          />
          <Redirect
            from={`${process.env.PUBLIC_URL + "/AboutTeam"}`}
            to={`${process.env.PUBLIC_URL + "/AboutUs"}`}
          />
          <Redirect
            from={`${process.env.PUBLIC_URL + "/service"}`}
            to={`${process.env.PUBLIC_URL + "/Service"}`}
          />
          <Redirect
            from={`${process.env.PUBLIC_URL + "/PersonalRealInvestment"}`}
            to={`${process.env.PUBLIC_URL + "/Service"}`}
          />
          <Redirect
            from={`${process.env.PUBLIC_URL + "/InvestmentStructuralDesign"}`}
            to={`${process.env.PUBLIC_URL + "/Service"}`}
          />
          <Redirect
            from={`${
              process.env.PUBLIC_URL + "/ProjectDevelopmentAndManagement"
            }`}
            to={`${process.env.PUBLIC_URL + "/Service"}`}
          />
          <Redirect
            from={`${process.env.PUBLIC_URL + "/PersonalHomeBuildingAdvice"}`}
            to={`${process.env.PUBLIC_URL + "/Service"}`}
          />
          <Redirect
            from={`${process.env.PUBLIC_URL + "/FirstHomeBuyers"}`}
            to={`${process.env.PUBLIC_URL + "/Service"}`}
          />
          <Redirect
            from={`${
              process.env.PUBLIC_URL + "/ExtensiveLandOldHouseRevitalization"
            }`}
            to={`${process.env.PUBLIC_URL + "/Service"}`}
          />
          <Redirect
            from={`${process.env.PUBLIC_URL + "/FinancePromise"}`}
            to={`${process.env.PUBLIC_URL + "/Service"}`}
          />
          <Redirect
            from={`${process.env.PUBLIC_URL + "/technologies"}`}
            to={`${process.env.PUBLIC_URL + "/AboutUs"}`}
          />
          <Redirect
            from={`${process.env.PUBLIC_URL + "/development"}`}
            to={`${process.env.PUBLIC_URL + "/AboutUs"}`}
          />
          <Redirect
            from={`${process.env.PUBLIC_URL + "/Contact"}`}
            to={`${process.env.PUBLIC_URL + "/contact"}`}
          />
        </Switch>
      </PageScrollTop>
    </Router>
  );
};

export default App;
